import { useMemo, useState } from 'react'
import { Card } from './CardComponent'
import { LineChart, BarChart, StackedBarChart } from 'react-native-gifted-charts'
import { View, Text } from 'react-native'
import theme from '../../../theme'
export const LineChartCard = ({ title, value, data = [] }) => {
    const [cardWidth, setCardWidth] = useState(150)
    return (
        <Card
            style={{
                overflow: 'hidden',
            }}
            setCardWidth={(w) => setCardWidth(w)}
        >
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 24, width: '100%' }}>
                <Text style={{ fontSize: 15, fontWeight: '600', maxWidth: '60%', color: theme.colors.textPrimary }}>{title}</Text>
                <Text style={{ fontSize: 18, fontWeight: '700', color: theme.colors.textPrimary }}>{value}</Text>
            </View>

            {/* Chart */}
            <View style={{ width: cardWidth, overflow: 'hidden' }}>
                <LineChart
                    width={cardWidth}
                    data={data}
                    curved
                    thickness={3}
                    hideRules
                    hideDataPoints
                    initialSpacing={0}
                    color='#6366f1'
                    startFillColor='#6366f1'
                    endFillColor='#6366f111'
                    startOpacity={0.25}
                    endOpacity={0.05}
                    yAxisThickness={0}
                    noOfSections={3}
                    animateOnDataChange
                    animationDuration={700}
                    spacing={cardWidth / data.length}
                    areaChart
                    pointerConfig={{
                        pointerStripHeight: 120,
                        pointerStripColor: '#6366f166',
                        radius: 6,
                        pointerColor: '#6366f1',
                    }}
                    disablePress
                />
            </View>
        </Card>
    )
}
export const SimpleDataBarChartCard = ({ title, data, styles }) => {
    const [cardWidth, setCardWidth] = useState(150)
    const YAxisTextWidth = 40
    const BarWidth = cardWidth - YAxisTextWidth
    return (
        <Card style={styles} setCardWidth={(w) => setCardWidth(w)}>
            <Text style={{ fontSize: 15, fontWeight: '600', marginBottom: 24, color: theme.colors.textPrimary }}>{title}</Text>

            <BarChart
                width={BarWidth}
                data={data}
                barWidth={36}
                spacing={12}
                barBorderRadius={0}
                initialSpacing={20}
                yAxisThickness={0}
                xAxisThickness={0}
                noOfSections={4}
                hideRules
                frontColor='#4E8EF5'
                yAxisLabelContainerStyle={{ width: 40 }}
                yAxisTextStyle={{ color: '#777' }}
                xAxisLabelTextStyle={{ color: '#555', fontWeight: '600', fontSize: 12 }}
                disablePress
            />
        </Card>
    )
}

export const ComparisonBarChart = ({ styles, title = '', data = [] }) => {
    const [cardWidth, setCardWidth] = useState(150)
    const YAxisTextWidth = 40
    const BarWidth = cardWidth - YAxisTextWidth
    // Convertimos en estructura compatible (2 barras por mes)
    const chartData = data.flatMap((item) => {
        return [
            {
                value: item.a,
                frontColor: '#6A5AE0',
                barWidth: 16,
                spacing: 2, // espacio interno del grupo
                label: '', // solo la PRIMER barra muestra label
            },
            {
                value: item.b,
                frontColor: '#4E8EF5',
                barWidth: 16,
                spacing: 22, // espacio grande para separar al siguiente grupo
                label: '', // segunda barra del grupo no repite label
                labelComponent: () => (
                    <View
                        style={{
                            position: 'absolute',
                            top: 5, // ajustá a gusto
                            left: -22, // 🔥 offset para centrar entre barra A y B
                            width: 60,
                            alignItems: 'center',
                        }}
                    >
                        <Text style={{ color: '#555', fontWeight: '600', fontSize: 12 }}>{item.label}</Text>
                    </View>
                ),
            },
        ]
    })

    return (
        <Card style={styles} setCardWidth={(w) => setCardWidth(w)}>
            <Text style={{ fontSize: 15, fontWeight: '600', marginBottom: 24, color: theme.colors.textPrimary }}>{title}</Text>

            <BarChart
                width={BarWidth}
                data={chartData}
                barBorderRadius={0}
                yAxisThickness={0}
                xAxisThickness={1}
                xAxisColor='#ccc'
                noOfSections={4}
                maxValue={1000}
                spacing={7}
                hideRules
                yAxisTextStyle={{ color: '#777' }}
                yAxisLabelContainerStyle={{ width: 40 }}
                xAxisLabelTextStyle={{ color: '#555', fontWeight: '600' }}
                disablePress
            />
        </Card>
    )
}
export const VerticalStackedBars = ({ styles, title = '', data = [] }) => {
    const [cardWidth, setCardWidth] = useState(150)
    const YAxisTextWidth = 40
    const BarWidth = cardWidth - YAxisTextWidth

    //Mapeo para agregar componente label custom
    const mapData = data.map((item) => {
        return {
            ...item,
            labelComponent: () => (
                <View
                    style={{
                        // position: 'absolute',
                        // top: 4,
                        left: -5,
                        // width: 70,
                        alignItems: 'center',
                    }}
                >
                    <Text style={{ color: '#555', fontWeight: '600', fontSize: 12 }}>{item.label}</Text>
                </View>
            ),
        }
    })
    return (
        <Card style={styles} setCardWidth={(w) => setCardWidth(w)}>
            <Text style={{ fontSize: 15, fontWeight: '600', marginBottom: 24, color: theme.colors.textPrimary }}>{title}</Text>

            <BarChart
                width={BarWidth}
                noOfSections={4}
                stackData={mapData}
                // rotateLabel
                yAxisThickness={0}
                xAxisThickness={0}
                disablePress
                yAxisTextStyle={{ color: '#777' }}
                xAxisLabelTextStyle={{ color: '#555', fontWeight: '600' }}
            />
            {/* <View style={{ height: 35 }} /> */}
        </Card>
    )
}
